export default __webpack_public_path__ + "static/media/6.a9733bf3.png";